

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>







<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>

<br><br>


<!-- topic -->
<div class="row"  data-aos="zoom-in" data-aos-delay="300" >
  <div class="col-md-6 text-center  ">
    <img style="width:70%;height: 100%;margin-top: 40px;border-radius: 50% 60%;" src="assets/dintop.png">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">Comprehensive DIN Verifications for your company </span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;Gain Thorough insights on your candidate’s past and present directorship to make better hiring decisions with Facheck </h5>
    </div>

   
</div>



<div class="row mt-4 p-3" data-aos="zoom-in" data-aos-delay="300"  >
    <div class="col-md-6 text-center ">
        <img src="assets/dinimportance.png">
    </div>
    <div class="col-md-6">
        <h2 style="color:#6ab187">Importance of DIN Verifications</h2>
        <p>Directorship checks are vital for protecting your business<br> from potential issues that can damage your brand and reputation.<br> Here’s how DIN verification helps employers to make better<br> hiring decisions</p>
        <h6><img style="width:20px;height: 20px;" src="assets/check-mark.png">Complete factual information is screened to avoid wrong hires</h6>
        <h6><img style="width:20px;height: 20px;" src="assets/check-mark.png">Avoid conflicts that may arise because of the candidate’s past shareholdings</h6>
        <h6><img style="width:20px;height: 20px;" src="assets/check-mark.png">Involvement of the candidates with companies that went bankrupt</h6>
        
    </div>
</div>
<br><br><br>

<!-- info -->
<div class="row"   >
    <div class="col">
        <h2 data-aos="zoom-in" data-aos-delay="300" style="color:#6ab187;text-align:center;">Information you’ll know
            through DIN Verifications</h2>
        <p data-aos="zoom-in" data-aos-delay="300"  style="text-align: center;">DIN Verification allows employers to gain a comprehensive understanding of their candidate’s past and present employment history. </p>
       
    </div>
</div>

<!--  -->

<div  class="row p-3" >

  <div data-aos="fade-up" data-aos-delay="300"  class="col-md-4">
      <br>
      <img style="width: 60px;height: 65px;" src="assets/legal.png">
     <br><br><br>
      <h5>STEP 1</h5>
      <p style="align-items: center;">Know if the candidate is associated with illegal incidents</p>
  </div>

  <div data-aos="fade-up" data-aos-delay="300" class="col-md-4">
        <br>
        <img style="width: 70px;height: 80px;" src="assets/pie-chart.png">
       <br><br>
        <h5>STEP 2</h5>
        <p style="align-items: center;">Access information such as the candidates share of the business</p>
    </div>
   
    <div data-aos="fade-up" data-aos-delay="300" class="col-md-4">
   
      <br>
      <img style="width: 60px;height: 60px;" src="assets/profile.png">
     <br><br><br>
      <h5 >STEP 3</h5>
      <p style="align-items: center;">Verify the authenticity of the candidates claim of their past directorship<p>
  </div>

</div>


<div class="row p-3" data-aos="fade-up" data-aos-delay="300"  >
  <div  class="col-md-6">
    
    <h2>Three Simple Steps to get started</h2>
    <br>
    <img style="width: 70%;height: 70%;box-shadow: 10px 10px;" src="assets/onboarding.jpg">
  </div>
  <div class="col-md-6">
    <br><br>
    <h4><img style="height: 29px;width: 29px;" src="assets/upload.png"> Upload candidate information </h4>
    <p>Initiate the verification process as soon as your candidates enter their unique eight – digit DIN</p>

    <br>
    <h4><img style="height: 30px;width: 30px;" src="assets/info.png">Verify the authenticity of the information provided</h4>
    <p>The Central Government’s Database is thoroughly scanned to confirm the candidate’s DIN code and find the potential discrepancies</p>

    <br>
    <h4><img style="height: 30px;width: 31px;" src="assets/hire.png">Hire the right person</h4>
    <p>Keep tabs on the verification process and get notified if there’s any discrepancy such as bankruptcy, fraud etc.</p>
  </div>
</div>


<br>
  <h1 data-aos="zoom-in" data-aos-delay="300"  style="text-align: center;color: #6ab187;">What makes Facheck Unique?​</h1><br>

  
  <div style="background-color: azure;" class="row p-2">
    <div class="col-md-3 mt-2 "  data-aos="fade-up" data-aos-delay="300"    >
        <div class="card" >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/onboardicon.png">
                <br><br>
              <h5 class="card-title">Easy Onboarding</h5>
            
                <br>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2 " data-aos="fade-up" data-aos-delay="300"    >

        <div class="card" >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/secure.png"><br>
                <br>
              <h5 class="card-title">Safe & Secure</h5>
           <br>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2 " data-aos="fade-up" data-aos-delay="300"   >

        <div class="card" >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/price.png">
                <br><br>
              <h5 class="card-title">Transparent Pricing</h5>
             
            <br>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2 " data-aos="fade-up" data-aos-delay="300"    >

        <div class="card"   >
            <div class="card-body" style="height:190px"  >
                <img style="width: 25%;height:29%" src="assets/workflow.png"><br><br>
                  <h4 class="card-title">Workflow Automation</h4>
             <br>
            </div>            
          </div>
    </div>
    
    <div class="col-md-3 mt-2 " data-aos="fade-up" data-aos-delay="300"    >
      <div class="card" >
          <div class="card-body">
              <img style="width: 25%;height:25%" src="assets/tailored.png">
              <br><br>
            <h5 class="card-title">Tailored Solutions based on your requirements</h5>
          
              <br>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2 " data-aos="fade-up" data-aos-delay="300"    >

      <div class="card" >
          <div class="card-body">
              <img style="width: 25%;height:25%" src="assets/remotefriendly.png"><br>
              <br>
            <h5 class="card-title">Remote-Friendly and Contactless Verifications</h5>
            
         <br>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2 " data-aos="fade-up" data-aos-delay="300"    >

      <div class="card" >
          <div class="card-body">
              <img style="width: 25%;height:25%" src="assets/iso.png">
              <br><br>
            <h5 class="card-title">Complaint with ISO 27001, PCI, and more</h5>
           
          <br>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2 " data-aos="fade-up" data-aos-delay="300"    >

      <div class="card" >
          <div class="card-body">
              <img style="width: 25%;height:29%;border-radius: 15px;" src="assets/ai.png">
              <br><br>
                <h5 class="card-title">Powered by AI</h5>
           <br>
            <br>
          </div>            
        </div>
  </div>

  </div>


  <!-- faq -->
  <div data-aos="zoom-in" data-aos-delay="300" class="faq-title text-center pb-3">
    <h2>FAQ</h2>
</div>


<div class="row" data-aos="zoom-in" data-aos-delay="300"    >
  <div id="slide" style="margin-top: 15%;" class="col-md-6">
    <h1 style="text-align:center;color: #6ab187;">FACheck's FAQ</h1>
   </div>
    <div class="col-md-6">
        <div style="width: 90%;" class="faq-content">
            <div class="faq-question">
              <input id="q1" type="checkbox" class="panel">
             
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q1" class="panel-title"> &nbsp;&nbsp;How do I Check if a DIN is valid? </label>
              <div class="panel-content">1. A DIN (Director Identification Number) is a unique 8-digit number issued by the Ministry of Corporate Affairs (MCA) to identify a company's directors.<br>
                2. To check if a DIN is valid, you can visit the MCA website and use the 'Verify DIN' tool.<br>
                3. You can also use the MCA21 portal to search for a director's details using their DIN.<br>
                4. Another way to check if a DIN is valid is to use a third-party service provider such as CDSL Ventures Limited.<br>
                5. You can also contact the MCA directly to verify the validity of a DIN.
              </div>
            </div>
            
            <div class="faq-question">
              <input id="q2" type="checkbox" class="panel">
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q2" class="panel-title">&nbsp;&nbsp; Is DIN KYC Mandatory? </label>
              <div class="panel-content">Yes, Din KYC is mandatory for companies registered in India. It is a mandatory requirement for all companies to obtain a Director Identification Number (DIN) from the Ministry of Corporate Affairs (MCA). The DIN is used to authenticate the identity of the directors of the company. It is a legal requirement for companies to obtain DINs for all directors. The DIN is also required for filing various forms and documents with the MCA. So, it is mandatory for companies to do Din KYC.</div>
            </div>
            
            <div class="faq-question">
              <input id="q3" type="checkbox" class="panel">
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q3" class="panel-title">&nbsp;&nbsp; What is DIN verification for employees?</label>
              <div class="panel-content">A DIN (Director Identification Number) verification for employees is a process of checking an individual's Director Identification Number as part of the pre-employment screening process. The DIN is a unique identification number issued by the Ministry of Corporate Affairs in India to individuals who have been appointed as directors of a company. 
                 </div>
            </div>
        
            <div class="faq-question">
                <input id="q4" type="checkbox" class="panel">
                
               <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
                <label for="q4" class="panel-title">&nbsp;&nbsp;Why is a DIN Verification necessary for employers? </label>
                <div class="panel-content">A DIN verification is necessary for employers to ensure that the individuals they are hiring have a clean track record and are suitable for the position. The DIN verification can help employers to identify any red flags such as criminal convictions or unresolved debts, and make informed hiring decisions.</div>
              </div>

              <div class="faq-question">
                <input id="q5" type="checkbox" class="panel">
                <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
                <label for="q5" class="panel-title">&nbsp;&nbsp;Is an employee’s consent required for a DIN Verification?</label>
                <div class="panel-content">Yes, an employee’s written consent is required for a DIN Verification. Employers should provide a clear explanation of the purpose of the check and how the information will be used. </div>
              </div>
             
          </div>
    </div>
  

</div>


 
<br><br><br>




